'use client';

import CtaSection, { CtaSectionProps } from 'components/padi-ui/cta-section';
import { TasticProps } from 'frontastic/tastics/types';

const CtaSectionTastic = ({ data }: TasticProps<CtaSectionProps>) => {
  return <CtaSection {...data} />;
};

export default CtaSectionTastic;
